import { memo } from 'react'
import isEqual from 'react-fast-compare'
import styled from 'styled-components'

import { decodeHtml } from '@nx/decode-html'
import { Label } from '@nx/fire/typography'
import { buildPriceString } from '@nx/helpers'
import { getTranslate } from '@nx/translations'

import translate from './WinningBid.translate.json'

const { text } = getTranslate(translate)

export const WinningBid = memo(
  ({ currencySymbol, price, ...props }: WinningBidProps) => (
    <StyledWinningBidLabel $level="M" {...props}>
      {text('winning', {
        price: buildPriceString({
          currencySymbol: decodeHtml(currencySymbol),
          lowPrice: price,
        }),
      })}
    </StyledWinningBidLabel>
  ),
  isEqual
)

export const StyledWinningBidLabel = styled(Label)`
  /* Empty for override styles */
`

export interface WinningBidProps {
  currencySymbol: string
  price: number
}
